/*
 * @Author: your name
 * @Date: 2020-04-01 10:46:26
 * @LastEditTime: 2020-04-20 15:10:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \cbh_front\src\config\index.js
 */
export default {
  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,
  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://localhost:8080',
    // dev: 'http://192.168.31.84:8882/official',
    // dev: 'http://120.25.251.163:9322/',
    // pro: 'http://120.25.251.163:9322/'

    dev: 'https://app.arcticdolphin.net/',
    pro: 'https://app.arcticdolphin.net/'

    // dev: 'https://littlesmoke.gdqunyu.com/',
    // pro: 'https://littlesmoke.gdqunyu.com/'
  },
  dimensionUrl: 'http://www.cbhcom.com/3d',
  // 小图路径
  minBaseUrl: 'http://chaobohui.cbh9999.com:8002/upfiles/sample/min/',
  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',
  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
      developmentOff: false // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
    }
  }
}
